/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Value_LabelInputs */

const vi_sales_return_value_label = /** @type {(inputs: Sales_Return_Value_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá trị hàng trả`)
};

/**

* @param {Sales_Return_Value_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_value_label = /** @type {((inputs?: Sales_Return_Value_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Value_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_value_label(inputs)
});